<template>
  <div class="page-wrap p-3">
    <div class="page-header p-3 mb-3 mt-3">
      <h3>Список специальностей по годам</h3>
      <div class="add-item-block mt-3 mb-3 d-flex justify-content-end" v-if="isAdmin()">
        <b-button variant="success" @click="onClickImport()">
          Импортировать данные
        </b-button>
      </div>

      <div class="filters">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="search" class="form-label col-md-2"></label>
            <div class="col-md-9">
              <div class="input-group">
                <input class="form-control" type="text" placeholder="Поиск по коду и наименованию"
                       id="search"
                       v-model="page.filter.search"
                       style="font-style: italic;">
                <button class="btn btn-primary" type="button" @click="reloadList()">
                  Найти
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="filterYear" class="form-label col-md-2">
              Год
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.year" id="filterYear"
                      v-on:change="reloadList()"
                      class="form-select">
                <option v-for="(year, index) in years" :key="index" :value="year">
                  {{ year }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="page-content mt-3 mb-3">
    <div class="page-content-info d-flex align-items-center justify-content-between">
      <div>Найдено: <span>{{ totalCount }}</span></div>
    </div>

    <b-table striped hover
             :items="items"
             :fields="fields"
             responsive="sm"
             no-local-sorting
             show-sort-labels>
      <template #head(year)="data">
        <div class="sortable-container none"
             @click="onSortChanged('year')"
             :class="{'ascending': page.sort.year === 'ASC', 'descending': page.sort.year === 'DESC'}">
          Год
        </div>
      </template>
      <template #head(code)="data">
        <div class="sortable-container none"
             @click="onSortChanged('code')"
             :class="{'ascending': page.sort.code === 'ASC', 'descending': page.sort.code === 'DESC'}">
          Код специальности
        </div>
      </template>
      <template #head(nameRu)="data">
        <div class="sortable-container none"
             @click="onSortChanged('nameRu')"
             :class="{'ascending': page.sort.nameRu === 'ASC', 'descending': page.sort.nameRu === 'DESC'}">
          Наименование специальности
        </div>
      </template>

      <template #head(type)="data">
        <div class="sortable-container none"
             @click="onSortChanged('type')"
             :class="{'ascending': page.sort.type === 'ASC', 'descending': page.sort.type === 'DESC'}">
          Тип
        </div>
      </template>
      <template #head(actions)="data" v-if="isAdmin()">
      </template>


      <template #cell(year)="data">
        {{ data.item.year }}
      </template>
      <template #cell(code)="data">
        {{ data.item.profession.code }}
      </template>
      <template #cell(nameRu)="data">
        <a :href="`/professions-cost/${data.item.uuid}`">
          {{ data.item.profession.nameRu }}
        </a>
      </template>
      <template #cell(type)="data">
        <a :href="`/professions-cost/${data.item.uuid}`">
          {{ data.item.type=='CREDIT'?'Кредит': (data.item.type=='MONTH'? 'Месяц': '') }}
        </a>
      </template>
      <template #cell(actions)="data" v-if="isAdmin()">
        <div class="action-cell">
          <b-button class="btn btn-danger btn-sm delete-button"
                    @click="onClickRemove(data.item)">
            Удалить
          </b-button>
        </div>
      </template>
    </b-table>
  </div>
  <div class="page-footer">
    <b-pagination
        v-model="page.partNumber"
        :total-rows="totalCount"
        :per-page="page.countInPage"
        v-on:click="reloadList"
        first-text="<<"
        last-text=">>"
        class="mt-3"
    ></b-pagination>
  </div>

  <!-- Modal component -->
  <b-modal v-model="showModal" title="Импорт суммы кредитов из шаблона" @ok="submitForm">
    <form @submit.prevent="submitForm" class="mb-4">
      <div class="mb-3">
        <label for="year" class="form-label">
          Год
          <span class="text-danger">*</span>
        </label>
        <div class="col-md-9">
          <input v-model="year" name="year" type="number" step="1" min="0" class="form-control inputYear"/>
        </div>
      </div>
      <div class="mb-3">
        <div class="el-input-group">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="isDeleteAll"
                   v-model="isDeleteAll"/>
            <label class="form-check-label" for="isDeleteAll">
              Удалить все данные за выбранный год перед импортом
            </label>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <label for="fileUpload" class="form-label">
          Выберите файл с данными (*.xlsx)
          <span class="text-danger">*</span>
        </label>
        <div class="col-md-9">
          <input type="file" id="fileUpload" @change="handleFileUpload" accept=".xlsx" class="form-control"/>
        </div>
      </div>
    </form>
  </b-modal>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import professionCostService from "@/services/professionCostService";
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import delegationService from "@/services/delegationService";

export default {
  components: {
    VueLoading
  },
  data() {
    return {
      isLoading: false,
      showModal: false,
      page: {
        filter: {
          search: null,
          year: new Date().getFullYear()
        },
        sort: {
          universityId: null,
          bin: null,
          nameRu: null,
          region: null
        },
        partNumber: 1,
        countInPage: 10,
      },
      totalCount: 0,
      fields: [
        {key: 'year', label: 'Год', sortable: true},
        {key: 'code', label: 'Код специальности', sortable: true},
        {key: 'nameRu', label: 'Наименование специальности', sortable: true},
        {key: 'type', label: 'Тип', sortable: true},
        {key: 'actions', label: '', sortable: false}
      ],
      items: [],
      years: Array.from({length: 11}, (v, i) => 2017 + i),
      year: new Date().getFullYear(),
      isDeleteAll: false,
      uploadedFile: null
    };
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.uploadedFile = file;
      } else {
        showErrorNotify("Выберите файл для загрузки");
      }
    },
    onClickImport() {
      this.showModal = true;
      this.uploadedFile = null;
      this.year = new Date().getFullYear();
    },
    async reloadList() {
      this.isLoading = true;
      const response = await professionCostService.getAll(this.page);
      this.items = response.list;
      this.totalCount = response.count;
      this.isLoading = false;
    },
    onSortChanged(column) {
      this.page.sort = {
        ...this.page.sort,
        [column]: this.page.sort[column] === 'ASC' ? 'DESC' : 'ASC'
      };
      this.reloadList();
    },
    async submitForm() {
      if (!this.uploadedFile || !this.year) {
        showErrorNotify("Убедитесь, что все обязательные поля заполнены");
        return;
      }

      this.isLoading = true;

      try {
        const formData = new FormData();
        formData.append('file', this.uploadedFile);
        formData.append('year', this.year);
        formData.append('isDeleteAll', this.isDeleteAll);

        await professionCostService.uploadTemplate(formData);

        this.reloadList();

        showSuccessNotify("Файл успешно загружен");
        this.showModal = false;
      } catch (error) {
        showErrorNotify("Ошибка при загрузке файла");
      } finally {
        this.isLoading = false;
      }
    },
    async onClickRemove(item) {
      const confirmed = await confirm("Вы уверены, что хотите удалить этот элемент?");
      if (confirmed) {
        try {
          await professionCostService.deleteByUuid(item.uuid);

          this.reloadList();

          showSuccessNotify('Успешно удалено');
        } catch (exc) {
          showErrorNotify('Возникла ошибка при удалении');
        }
      }
    },
    isAdmin() {
      return delegationService.isAdmin();
    }
  },
  mounted() {
    this.reloadList();
  }
};
</script>

<style scoped>
.filters {
  .row {
    padding-top: 5px;
  }
}

.ascending {
  background-image: url("../../assets/asc.svg") !important;
}

.descending {
  background-image: url("../../assets/desc.svg") !important;
}

.none {
  background-image: url("../../assets/none.svg");
  margin-left: 10px !important;
}

.sortable-container {
  background-position: right calc(0.75rem / 2) center;
  background-repeat: no-repeat;
  background-size: 0.65em 1em;
  vertical-align: middle !important;
  margin-right: 10px !important;
  padding-right: 15px !important;
  cursor: pointer;
}

th div {
  width: 100% !important;
  display: grid !important;
}

.p-3 {
  padding: 0 !important;
}

.action-cell {
  display: flex;
  justify-content: flex-end;
}

.delete-button {
  display: flex;
  align-items: center;
}

</style>
